import React, { Component } from 'react';
import FilterBasic from '../../../basicElement/FilterBasic';
import API_URL from '../../../../common/url';

const applyStatusOption = [
    { label: '待审批', value: 'Pending_Approval' },
    { label: '审批通过', value: 'Approval_Success' },
    { label: '审批不通过', value: 'Approval_Failed' },
    { label: '拒绝变更', value: 'Approval_REJECT' },
];

class Filter extends Component {
    render() {
        const { businessList, ...rest } = this.props;
        const { invState } = sessionStorage;
        const isTotal = invState == 1;

        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const filters = [{
            name: '申请编号',
            key: 'applyCode',
            type: 'input',
        }];
        if (!isTotal) {
            filters.push( {
                name: '项目简称',
                key: 'investigation',
                type: 'searchRetrieve',
                typeProperty: {
                    keyword: 'investigationName',
                    style: {width: 160},
                    placeholder: '输入名称检索',
                    params: {limit: 20},
                    url: API_URL.investigation.queryInvestigationByName,
                    config: { id: 'investigationId', name: 'investigationName' }
                }
            });
        }
        filters.push({
            name: 'JDE项目号',
            key: 'jdeContractCode',
            type: 'input',
        });
        if (!isTotal) {
            filters.push({
                name: '业务线',
                key: 'lineOfBusiness',
                type: 'select',
                typeProperty: {
                    list: businessOption,
                }
            });
        }
        filters.push({
            name: '申请状态',
            key: 'applyStatus',
            type: 'select',
            typeProperty: {
                list: applyStatusOption,
            }
        });
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractInfoChange/components/Filter.js